<script lang="ts">
  import { Toaster } from 'svelte-sonner';
  import { theme } from '~/theme/darkMode.svelte';
</script>

<Toaster richColors position="top-center" theme={theme.current} />

<style lang="scss">
  @use '~/theme/theme';
  @use 'sass:color';

  :global([data-sonner-toast]) {
    border-radius: 999px !important;
    border-width: 2px !important;
  }

  :global([data-sonner-toaster]) {
    --font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    --font-size: 1rem;
    --success-bg: #{theme.$star-bonus} !important;
    --success-border: #{color.scale(theme.$star-bonus, $lightness: -20%)} !important;
    --success-text: white !important;
    --warning-bg: #{theme.$star} !important;
    --warning-border: #{color.scale(theme.$star, $lightness: -20%)} !important;
    --warning-text: #{theme.$tile-default-dark} !important;
    --error-bg: #{theme.$star-penalty} !important;
    --error-border: #{color.scale(theme.$star-penalty, $lightness: -20%)} !important;
    --error-text: white !important;
  }

  :global([data-sonner-toaster][data-sonner-theme='light']) {
    --normal-bg: white;
    --normal-border: #{theme.$tile-default-dark};
    --normal-text: #333;
  }

  :global([data-sonner-toaster][data-sonner-theme='dark']) {
    --normal-bg: #{theme.$tile-default-dark};
    --normal-border: rgba(255, 255, 255, 0.2);
    --normal-text: white;
  }
</style>
